import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
// import Grid from '@mui/material/Grid';
// !!! import Grid from '@mui/material/Unstable_Grid2';
import Grid from '@mui/material/Grid';

// not exists: import Grid from '@mui/material/Grid2';
import OutlinedInput from '@mui/material/OutlinedInput';
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AlarmIcon from '@mui/icons-material/Alarm';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import SimCardRoundedIcon from '@mui/icons-material/SimCardRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import SearchIcon from '@mui/icons-material/Search';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import SendIcon from '@mui/icons-material/Send';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ClearIcon from '@mui/icons-material/Clear';

import { styled } from '@mui/system';

import { DataGrid, GridRowsProp, GridColDef,GridRowId,GridToolbar,GridRowSelectionModel, GridRenderCellParams } from '@mui/x-data-grid';

import { FunctionComponent, useEffect } from 'react'
import useLocalStorageState from 'use-local-storage-state'

import { Quantifier } from '../Quantifier'
import { PrCartProps,PrBrandsIf } from '../Products'
import {PrAvProvider, PrAvContext, usePrAvcontext} from '../../context/PrAVContext'

import { TotalPrice } from '../TotalPrice'
import { Operation } from '../Quantifier/Quantifier'
import classes from './cart.module.scss'
import { useLocation } from 'react-router-dom'

import {round} from '../../utils'

import {useAuth} from '../../context/AuthContext'
import {Ibu, Iuserinfo,iauthData} from '../../context/AuthContextTypes'
import {IPrAvResponseData,IPrAvResponse,IPrOrderResponseData,IPrOrderResponse} from '../../pages/PageInterfaces'

import CircularProgress from '@mui/material/CircularProgress';

import KsrgrButton from '../../pages/components/KsrgrButton'

import { returnBasenameUrl } from '../../utils';

interface IPrBasketRow {
  id: number,
  title: string,
  price: number,
  quantity: number,
  code: string,
  code2: string,
  name: string,
  name1: string,
  uom: number,
  uomcode: string,
  uomname: string,
  pricer: number,
  pricew: number,
  brand: number,
  brandcode: string,
  brandname: string,
  mtrsup: number,
  info: string,
  origin: string,
  remqty: number,
  ordered: number,
  reserved: number,
  avqty: number,
  reqqty: number,
  lineval: number,
  discntperc: number,
  discntamnt: number,
  netlineval: number,
  thumbnail: string,
  image: string,
}

interface IPrBasketExpn {
  expndescription: string,
  expnnetval: number,  
}

interface IPrBasketSums {
  rows: number, 
  totqty: number, 
  totval: number,   
  totexpnval: number, 
  totamount:number,
  discntperc: number,
  discntamnt: number,
  totalnetval: number, 
  vatperc: number,
  totvatval: number,
  totsumval: number,
}

function getCartLength(cartobj:PrCartProps|undefined)
{
  return Object.values(cartobj || {}).reduce((accumulator, product) => accumulator + 1, 0)
}

const VATPERC=24.0

const FormGrid = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const PrCart: FunctionComponent = () => {
  let auth = useAuth();
  let pravcntxt = usePrAvcontext()
  let prBrandsInfo=pravcntxt.prContextData.prBrandsInfo as PrBrandsIf
  const [prcart, setPrCart] = useLocalStorageState<PrCartProps>(`${process.env.REACT_APP_PRCARTKEYNAME}`, {})
  const [prbrand, setPrBrand] = useLocalStorageState(`${process.env.REACT_APP_PRCARTBRANDKEY}`, {defaultValue:''})
  const location = useLocation()
  const [basketsum, setBasketsum]=React.useState({
    basketlines: 0,
    totalQuantity: 0,
    totalPrice: 0,
    totval: 0,
    expnamnt: 0,
    totamount:0,
    discprcnt: 0,
    discamnt: 0,
    totalnetval:0,
    vatamnt:0,
    totsumval:0
  })
  const [isPosting, setIsPosting] = React.useState(false)
 // calcCartSums()
  const handleRemoveProduct = (productId: number): void => {
    const lisInCart = Object.keys(prcart || {}).includes(productId.toString())
    const lgetProducts = () => Object.values(prcart || {})
    const lbasketlines = getProducts().reduce((accumulator, product) => accumulator + 1, 0)
    setPrCart((prevCart) => {
      const updatedCart = { ...prevCart }
      delete updatedCart[productId]
      return updatedCart
    })
    if(lisInCart===true && lbasketlines<=1){
      setPrBrand('')
    }
    setBasketsum(calcCartSums())
  }

  function handleBtnDelBasketRow(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, rowboj:any){
    console.log('btn delete cart row selected',rowboj,'id=',rowboj.id)
    handleRemoveProduct(rowboj.id)
  }

  const prBasketColumns : GridColDef[] = [  // , width: 150
    { field: 'code',
      type: 'string',
      headerName: 'Κωδικός',
      disableReorder: true,
      hideable: false,
      flex:1
    },
    {
      field: 'name',
      type: 'string',
      headerName: 'Περιγραφή',
      disableReorder: true,
      hideable: false,
      flex:2
    },
    { field: 'reqqty',
    type: 'number',
    headerName: 'Z.Ποσ.',
    disableReorder: true,
    hideable: false,
    flex:1
    },
    {
      field: 'pricer',
      type: 'number',
      headerName: 'Τιμή Λ',
      disableReorder: true,
      hideable: false,
      flex:2,
      renderCell: (params: GridRenderCellParams<any, number>) => (
        <strong>
            {params.value ? params.value.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) : params.value }
         </strong>
        ),
    },
    {
      field: 'lineval',
      type: 'number',
      headerName: 'Αξία',
      disableReorder: true,
      hideable: false,
      flex:2,
      renderCell: (params: GridRenderCellParams<any, number>) => (
        <strong>
            {params.value ? params.value.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) : params.value }
         </strong>
        ),
    },
    {
      field: 'id',
      type: 'number',
      headerName: ' X ',
      disableReorder: true,
      hideable: false,
      flex:1,
      renderCell: (params: GridRenderCellParams<any, number>) => (
        <strong>
            <IconButton color="primary" aria-label="delete row" tabIndex={params.hasFocus ? 0 : -1}
              onClick={(e)=>{handleBtnDelBasketRow(e, params.row)}}>
              <DeleteIcon />
            </IconButton>
          </strong>
        ),
    }
  ]
  type Order = 'asc' | 'desc';
  function getRowId(row:IPrBasketRow) {
    return row.id;
  }

  /* useEffect(() => {
    window.scrollTo(0, 0)
  }, [location]) */

  const getProducts = () => Object.values(prcart || {})
  //const basketlines = getProducts().reduce((accumulator, product) => accumulator + 1, 0)
  //const totalQuantity = getProducts().reduce((accumulator, product) => accumulator + (product.reqqty), 0) 
  //const totalPrice = getProducts().reduce((accumulator, product) => accumulator + (product.price * product.quantity), 0)
  function calcCartSums() {
    let lbasketlines = getProducts().reduce((accumulator, product) => accumulator + 1, 0)
    let ltotalQuantity = getProducts().reduce((accumulator, product) => accumulator + (product.reqqty), 0) 
    let ltotalPrice = getProducts().reduce((accumulator, product) => accumulator + (product.price * product.quantity), 0)
    let totval=getProducts().reduce((accumulator, product) => accumulator + (product.price * product.quantity), 0);
    let discprcnt=0;
    let discamnt=0;
    let vatamnt=0;
    let expnamnt=0;
    let prBrandinfo = prBrandsInfo[parseInt(prbrand)]
    if(prBrandinfo===undefined || prBrandinfo===null || ('discntlevels' in prBrandinfo === false) || ('expnamntlevels' in prBrandinfo === false) ){
      // do notthing, ;et zero values
      console.log('PrCart, calcCartSums, prbrand=',prbrand,'prBrandinfo indefined or ')
    }
    else {
      prBrandinfo.discntlevels.forEach( (discntlevel)=>{
        // discntlevel : [min<, <=max, perc]
        if( totval>discntlevel[0] && totval<=discntlevel[1]) discprcnt=discntlevel[2]
      })
      prBrandinfo.expnamntlevels.forEach( (expnamntlevel)=>{
        // expnamntlevel : [min<, <=max, amnt]
        if( totval>expnamntlevel[0] && totval<=expnamntlevel[1]) expnamnt=expnamntlevel[2]
      })
    }
    console.log('PrCart, calcCartSums, prbrand=',prbrand,'totval=',totval,'discprcnt=',discprcnt,'expnamnt=',expnamnt)
    // Object.entries(prBrandsInfo).map( value  => {
    // return <MenuItem  key={value[0]} value={value[0]}>{value[1].marktitle}</MenuItem>} )
    /*
    if(parseInt(prbrand)!==200) {   // not KAWASKI supplier or Brand
      discprcnt=30;
    }
    else {
      if(totval<=300) {
        discprcnt=25
      }
      else if(totval>300 && totval<=800 ) {
        discprcnt=30
      }
      else if(totval>800 && totval<=1500 ) {
        discprcnt=33
      }
      else {
        discprcnt=35
      }
    }
    if(totval<=300) {
      expnamnt=30
    }
    */
    let totamount = totval; // + expnamnt;
    discamnt=totamount * (discprcnt/100);
    discamnt=round(discamnt,2)
    let totalnetval=(totamount-discamnt) + expnamnt;
    vatamnt=totalnetval * (VATPERC/100);
    vatamnt=round(vatamnt,2)
    let totsumval = totalnetval + vatamnt;
    return {
      basketlines: lbasketlines,
      totalQuantity: ltotalQuantity,
      totalPrice: ltotalPrice,
      totval: totval,
      expnamnt: expnamnt,
      totamount: totamount,
      discprcnt: discprcnt,
      discamnt: discamnt,
      totalnetval: totalnetval,
      vatamnt: vatamnt,
      totsumval: totsumval
    }
    /* return {
      totval: totval,
      expnamnt: expnamnt,
      totamount: totamount,
      discprcnt: discprcnt,
      discamnt: discamnt,
      totalnetval: totalnetval,
      vatamnt: vatamnt,
      totsumval: totsumval
    } */
  }
  /*   function handleBtnDelBasketRow(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, rowboj:any){
    console.log('btn delete cart row selected',rowboj)
    if( (rowboj) && (rowboj.id) && prbasket !==undefined && prbasket !==null && prbasket.length>0 )
    {
      var index = prbasket.findIndex( (elem) =>  elem.id === rowboj.id )
      if(index!==undefined){
        let rows=0;
        let totqty=0
        let totval=0;

        let discprcnt=0;
        let discamnt=0;
        let vatamnt=0;
        let expnamnt=0;
        
        let newprbasket =  [...prbasket] 
        newprbasket.splice(index,1)
        if(newprbasket.length>0){
          newprbasket.forEach( (elem)=>{
            rows++;
            totqty+=elem.reqqty
            totval+=elem.lineval
          })
          setPrbasket(newprbasket)
          if(parseInt(prbrand)!==200) {   // not KAWASKI supplier or Brand
            discprcnt=30;
          }
          else {
            if(totval<=300) {
              discprcnt=25
            }
            else if(totval>300 && totval<=800 ) {
              discprcnt=30
            }
            else if(totval>800 && totval<=1500 ) {
              discprcnt=33
            }
            else {
              discprcnt=35
            }
          }
          if(totval<=300) {
            expnamnt=30
          }
          let totamount = totval + expnamnt;
          discamnt=totamount * (discprcnt/100);
          discamnt=round(discamnt,2)
          let totalnetval=totamount-discamnt
          vatamnt=totalnetval * (VATPERC/100);
          vatamnt=round(vatamnt,2)
          setBasketsum({rows: rows, 
            totqty: totqty, 
            totval: totval,   
            totexpnval: expnamnt, 
            totamount: totamount,
            discntperc: discprcnt,
            discntamnt: discamnt,
            totalnetval: totalnetval, 
            vatperc: VATPERC,
            totvatval: vatamnt,
            totsumval: totalnetval + vatamnt})
        }
        else {
          setPrbasket([])
          setBasketsum({rows: 0, 
            totqty: 0, 
            totval: 0,   
            totexpnval: 0, 
            totamount: 0,
            discntperc: 0,
            discntamnt: 0,
            totalnetval: 0, 
            vatperc: 0,
            totvatval: 0,
            totsumval: 0})
        }
      }
    }

  }
  */
 
  React.useEffect( ()=>{
    console.log('useEffect [prbrand] basketsum=',basketsum)
    setBasketsum(calcCartSums())
  },[prbrand])

  React.useEffect( ()=>{
    console.log('useEffect [] basketsum=',basketsum)
    setBasketsum(calcCartSums())
  },[])

  /* React.useEffect( ()=>{
    let basketlines = Object.values(prcart || {}).reduce((accumulator, product) => accumulator + 1, 0);
    let totalQuantity = Object.values(prcart || {}).reduce((accumulator, product) => accumulator + (product.reqqty), 0) 
    let totalPrice = Object.values(prcart || {}).reduce((accumulator, product) => accumulator + (product.price * product.quantity), 0)
    let basketsums = calcCartSums()
    setBasketsum({
      basketlines: basketlines,
      totalQuantity: totalQuantity,
      totalPrice: totalPrice,
      totval: basketsums.totval,
      expnamnt: basketsums.expnamnt,
      totamount: basketsums.totamount,
      discprcnt: basketsums.discprcnt,
      discamnt: basketsums.discamnt,
      totalnetval: basketsums.totalnetval,
      vatamnt: basketsums.vatamnt,
      totsumval: basketsums.totsumval
    })
    console.log('useEffect calcCartSums basketsums=',basketsums,'basketlines=',basketlines)
  },[calcCartSums])

  React.useEffect( ()=>{
    let basketlines = getCartLength(prcart);
    let totalQuantity = Object.values(prcart || {}).reduce((accumulator, product) => accumulator + (product.reqqty), 0) 
    let totalPrice = Object.values(prcart || {}).reduce((accumulator, product) => accumulator + (product.price * product.quantity), 0)
    let basketsums = calcCartSums()
    setBasketsum({
      basketlines: basketlines,
      totalQuantity: totalQuantity,
      totalPrice: totalPrice,
      totval: basketsums.totval,
      expnamnt: basketsums.expnamnt,
      totamount: basketsums.totamount,
      discprcnt: basketsums.discprcnt,
      discamnt: basketsums.discamnt,
      totalnetval: basketsums.totalnetval,
      vatamnt: basketsums.vatamnt,
      totsumval: basketsums.totsumval
    })
    console.log('useEffect getCartLength basketsums=',basketsums,'basketlines=',basketlines)

  },[getCartLength,calcCartSums])
  */

  /* let basketlines = Object.values(prcart || {}).reduce((accumulator, product) => accumulator + 1, 0);
  let totalQuantity = Object.values(prcart || {}).reduce((accumulator, product) => accumulator + (product.reqqty), 0) 
  let totalPrice = Object.values(prcart || {}).reduce((accumulator, product) => accumulator + (product.price * product.quantity), 0)
  let basketsums = calcCartSums()
  setBasketsum({
    basketlines: basketlines,
    totalQuantity: totalQuantity,
    totalPrice: totalPrice,
    totval: basketsums.totval,
    expnamnt: basketsums.expnamnt,
    totamount: basketsums.totamount,
    discprcnt: basketsums.discprcnt,
    discamnt: basketsums.discamnt,
    totalnetval: basketsums.totalnetval,
    vatamnt: basketsums.vatamnt,
    totsumval: basketsums.totsumval
  }) */

  console.log('basketsum=',basketsum)
  const basketTitle = (parseInt(prbrand)!==undefined && isNaN(parseInt(prbrand))===false && parseInt(prbrand)>0) ? prBrandsInfo[parseInt(prbrand)].marktitle : ''
  


  const handleUpdateQuantity = (productId: number, operation: Operation) => {
    setPrCart((prevCart) => {
      const updatedCart = { ...prevCart }
      if (updatedCart[productId]) {
        if (operation === 'increase') {
          updatedCart[productId] = { ...updatedCart[productId], quantity: updatedCart[productId].quantity + 1 }
        } else {
          updatedCart[productId] = { ...updatedCart[productId], quantity: updatedCart[productId].quantity - 1 }
        }
      }
      return updatedCart
    })
  }

  function btnSendBasket(){
    if(auth.userData.success!==true) return

    if(auth.userData.partsaccesslevel===undefined || auth.userData.partsaccesslevel===null || auth.userData.partsaccesslevel<1) {
      console.log('PRCART SENDBASKET, not auth for parts access')
      return
    }
    if(auth.userData.partsaccesslevel<2) {
      alert('Posting Part Order is now allowed')
      return
    }
    // {Ibu, Iuserinfo,iauthData}
    let userinfo:Iuserinfo = auth.userData.userinfo as Iuserinfo
    let uprbu:Ibu  = { 
      WEBSERVICE:0,
      bu: 0,
      buname: '',
      trdr: 0,
      trdbame: '',
      trdbranch: 0,
      trdbrnname: '',
      trdafm: '',
      whs: '',
      accesslevel: 0
    }
    userinfo.bus.forEach( (obu,index, arribu)=>{
      if(obu.bu===20){
        uprbu=obu
      }
    })
    if(uprbu.bu!==20){
      console.log('PRCART SENDBASKET, undefined userino parts bu')
      return
    }

    let cartlines = getCartLength(prcart)
    if( cartlines<=0 ){
      alert('Posting Empty Part Order is now allowed')
      return
    }

    setIsPosting(true)

    let token = auth.userData.token
    let usercode = auth.userData.username
    let postdata = {
      service: "postprorder", 
      usercode: usercode,
      userid: auth.userData.userid,
      webservice: uprbu.WEBSERVICE,
      bu: uprbu.bu,
      buname:  uprbu.buname,
      trdr:  uprbu.trdr,
      trdbame:  uprbu.trdbame,
      trdbranch:  uprbu.trdbranch,
      trdbrnname:  uprbu.trdbrnname,
      trdafm:  uprbu.trdafm,
      whs:  uprbu.whs,
      accesslevel:  uprbu.accesslevel,
      webusername: userinfo.WEBUSERNAME,
      webuseremail: userinfo.WEBUSEREMAIL,
      parts: [] as any,
      expn: (basketsum.expnamnt>0) ? 106 : 0 ,
      expnval: basketsum.expnamnt,
      discntperc: basketsum.discprcnt,
      discntamnt: basketsum.discamnt,
      clientid: token
    }
    let successPost = false
    let postError = ''
    getProducts().forEach( (row)=>{
      postdata.parts.push( {
        id: row.id,
        code: row.code,
        reqqty: row.reqqty,
        pricew: row.pricew,
        pricer: row.pricer,
      } )
    })

    let body = JSON.stringify(postdata)
    let basename=returnBasenameUrl()
    let url =`${basename}${process.env.REACT_APP_B2B_API_URL}`;
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body 
    })
    .then((response) =>  {
      if (!response.ok) return {} 
      else return response.json()
    })
    .then((data:any) => {
      // console.log("PRCART SENDBASKET, post Pr Order then ... data=",data)
      const isSuccessPrOrderfoResponse = (data: any): data is IPrOrderResponse =>
      typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ; 
      if (isSuccessPrOrderfoResponse(data) && data.success!==true)
      {
        successPost = false
        postError = 'Posting Parts Order failed.'
        if(data.hasOwnProperty('error') && typeof data.error === 'string'){
          postError += ` Reason: ${data.error}`
        }
        else postError += ` Reason: unkwown`
        // console.log("PRCART SENDBASKET, post Pr Order NOT Success ")        
      }
      else {
        // console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
        if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && data.totalcount>0 && typeof data.data === 'object'){
          let responseData = data.data as IPrOrderResponseData
          if(responseData.orderid>0){
            successPost = true
            alert(`Your order has been succesfully posted with OrderCode ${responseData.ordercode} and total amount ${responseData.orderprice}`)
          }
          else {
            successPost = false
            postError = 'Posting Parts Order failed. Reason: Invalid Order Id returned'
          }
        }
        else {
          successPost = false
          postError = 'Posting Parts Order failed. Reason: No data information returned'
        }
      }
      if(successPost === false) {
        alert(postError)
      }
      else {
        clearBasket()
      }
    })
    .catch( (err) =>{      
      successPost = false
      postError = 'Posting Parts Order failed. Reason: '+err.message
      alert(postError)
    })
    .finally(()=>{
      setIsPosting(false)
    })
  }


  const clearBasket = () => {
    setPrCart({})
    setPrBrand('')
  }
  function btnClearBasket(){
    clearBasket()
  }

  return (
    <section className={classes.cart}>
      <h1>Καλάθι Παραγγελίας Ανταλλακτικών {basketTitle}</h1>
      {isPosting===true && <CircularProgress />}
      { /* start of muix data-grid  */ }
      <div className={classes.container}>
      <DataGrid rows={getProducts()} columns={prBasketColumns} getRowId={getRowId} density={'compact'}
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
        }}
        pageSizeOptions={[25, 50]}
        disableColumnMenu        
        checkboxSelection={false}   
        disableMultipleRowSelection={true}
        onRowSelectionModelChange = {(rowSelectionModel, details) => {
          // console.log("rowSelectionModel",rowSelectionModel)
          // console.log("details",details)
          //  ........ setMotoselected(rowSelectionModel)
        }}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          columnsManagement: {
            toggleAllMode: 'filteredOnly',          
          },       
          filterPanel: {
            disableAddFilterButton: true,
            disableRemoveAllButton: true,
          },
          toolbar: {printOptions: { disableToolbarButton: true },csvOptions: { disableToolbarButton: true },}
        }} 
      />
      <TotalPrice amount={basketsum.totalPrice} />
      <Box>
        <Alert>
          {'Σύνολο Γραμμών: '}{basketsum.basketlines.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          {' | Σύνολο Ποσοτήτων: '}{basketsum.totalQuantity.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          {' | Σύνολο Καθαρής Αξίας: '}{basketsum.totalPrice.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          {' | %εκπτωση: '}{basketsum.discprcnt.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          {' | Εξοδα (μεταφορικά): '}{basketsum.expnamnt.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          {' | Σύνολο μετά την εκπτωση: '}{basketsum.totalnetval.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          {' | Ποσό ΦΠΑ: '}{basketsum.vatamnt.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          {' | Τελικό Σύνολο: '}{basketsum.totsumval.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </Alert>
      </Box>
      <Box>

      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid >
          {basketsum.basketlines>0 && <Button variant="contained" endIcon={<SendIcon />} color="success" onClick={(e)=>{btnSendBasket()}}>αποστολη παραγγελιας</Button> }
        </Grid>
        <Grid >
          <Button variant="contained" endIcon={<ClearIcon />} color="warning" onClick={(e)=>{btnClearBasket()}} >Εκκαθαριση Καλαθιου</Button>
        </Grid>
      </Grid>

      </Box>
      </div>
      { /* end of muix data-grid  */ }
     
     { /*
      <div className={classes.container}>
        {getProducts().map(product => (
          <div className={classes.product} key={product.id}>
            { / * <img src={product.thumbnail} alt={product.title} /> * / }
            <h3>{`${product.code} ${product.title}, ${product.brandname}`}</h3>
            <Quantifier
              removeProductCallback={() => handleRemoveProduct(product.id)}
              productId={product.id}
              handleUpdateQuantity={handleUpdateQuantity} />
          </div>
        ))}
      </div>
      */ }
      
    </section>
  )
}

